import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import Modal from 'out-game/components/Modal'
import { IconButton } from 'out-game/components'
import { ReactComponent as Cross } from 'out-game/images/icons/cross-icon.svg'
import { useRequestGetMainBanner } from '../hooks/useRequest'
import { MainBanner } from 'out-game/types'
import { lsManager } from '../utils/localstorage'
import { URL_BASE } from 'out-game/constants'

const useStyles = makeStyles({
  root: {
    backgroundColor: '#2F425E',
    borderWidth: 1,
    borderColor: 'hsl(var(--col-base-white) / 0.2)',
    boxShadow: '0px 50px 70px 50px #031633',
    borderRadius: 'var(--border-radius)',
    borderStyle: 'solid',
    display: 'block',
    position: 'relative',
    height: 512,
    overflow: 'hidden',
  },
  iconClose: {
    width: 22,
    position: 'absolute',
    top: 15,
    right: 15,
  },
  bannerLink: {
    display: 'block',
    width: '100%',
    height: '100%',
  },
  bannerImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
})

const PopupOnMain: React.FC = () => {
  const [getMainBanner] = useRequestGetMainBanner()
  const classes = useStyles()
  const [isOpen, setOpen] = useState(true)
  const [banner, setBanner] = useState<MainBanner>()

  const onClose = () => setOpen(false)

  useEffect(() => {
    getMainBanner()
      .then(({ data }) => setBanner(data))
      .catch(console.error)
  }, [getMainBanner])

  if (lsManager.language && !banner?.[lsManager.language]) {
    return null
  }

  return (
    <Modal
      className="wallet-modal__window"
      open={isOpen}
      onClose={onClose}
      isOuterClickNotClose
    >
      <div className={classes.root}>
        <IconButton
          className={classes.iconClose}
          Icon={Cross}
          onClick={() => onClose()}
        />
        <a
          href={banner?.[lsManager.language]?.link}
          className={classes.bannerLink}
          target="_blank"
          rel="noreferrer noopener"
        >
          <img
            className={classes.bannerImage}
            src={`${URL_BASE}${banner?.[lsManager.language]?.image}`}
            alt={banner?.[lsManager.language]?.link}
          />
        </a>
      </div>
    </Modal>
  )
}

export default PopupOnMain
